import carouselCss from './Carousel.module.css';

// The number of columns (numColumns) affects styling and responsive images
export const COLUMN_CONFIG = [
  { 
    css: carouselCss.oneColumn, 
    responsiveImageSizes: '(max-width: 767px) 100vw, 1200px' 
  },
  { 
    css: carouselCss.twoColumns, 
    responsiveImageSizes: '(max-width: 767px) 100vw, 600px' 
  },
  { 
    css: carouselCss.threeColumns, 
    responsiveImageSizes: '(max-width: 767px) 100vw, 400px' 
  },
  { 
    css: carouselCss.fourColumns, 
    responsiveImageSizes: '(max-width: 767px) 100vw, 290px' 
  },
];

const getIndex = numColumns => Math.max(0, Math.min(numColumns - 1, COLUMN_CONFIG.length - 1));

export const getColumnCSS = numColumns => {
  const config = COLUMN_CONFIG[getIndex(numColumns)];
  return config ? config.css : COLUMN_CONFIG[0].css;
};

export const getResponsiveImageSizes = numColumns => {
  const config = COLUMN_CONFIG[getIndex(numColumns)];
  return config ? config.responsiveImageSizes : COLUMN_CONFIG[0].responsiveImageSizes;
}; 